module.exports = __webpack_public_path__ + "static/media/hero.afdfc8fd.svg";